import { render } from "./P048.vue?vue&type=template&id=017d1381&scoped=true"
import script from "./P048.vue?vue&type=script&lang=js"
export * from "./P048.vue?vue&type=script&lang=js"

import "./P048.vue?vue&type=style&index=0&id=017d1381&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-017d1381"]])

export default __exports__